import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=351d8a1a&scoped=true"
import script from "./layout-default.vue?vue&type=script&lang=js"
export * from "./layout-default.vue?vue&type=script&lang=js"
import style0 from "./layout-default.vue?vue&type=style&index=0&id=351d8a1a&prod&lang=scss&scoped=true"
import style1 from "./layout-default.vue?vue&type=style&index=1&id=351d8a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d8a1a",
  null
  
)

export default component.exports